import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-input-label',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex justify-between gap-2">
      <label
        [htmlFor]="labelFor"
        [ngClass]="labelClass"
        class="block text-base leading-6 text-mango-gray700 font-normal"
      >
        <ng-content></ng-content>
      </label>
      @if (isRequired) {
          <span class="text-sm leading-6 text-gray-500">*required field</span>
      } @else if (isRequired == false) {
        <span class="text-sm leading-6 text-gray-500">*optional field</span>
      }
    </div>
   `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputLabelComponent {
  @Input() labelFor!: string;
  @Input() labelClass!: string;
  @Input() isRequired!: Boolean | null
}
